import useLoginCheck from 'hooks/common/useLoginCheck';
import { getMemo, updateMemo } from 'lib/api/error';
import { useState } from 'react';
import { useQuery, useMutation, useQueryClient } from 'react-query';

const useErrorMemoModal = (id, closeModal) => {
  const queryClient = useQueryClient();

  const [contents, setContents] = useState('');
  const [date, setDate] = useState(new Date());

  const updateMemoMutation = useMutation(updateMemo, {
    onError: e => {
      if (e.response.statue === 500) throw e;
    },
    onSuccess: () => {
      queryClient.invalidateQueries('errorList');
      closeModal();
    },
  });
  useLoginCheck(updateMemoMutation.error?.response, () => {
    updateMemoMutation.mutate({
      id,
      memo: contents,
      doneAt: date,
    });
  });

  const getMemoQuery = useQuery('memo', () => getMemo(id));
  useLoginCheck(getMemoQuery.error?.response, getMemoQuery.refetch);
  const memo = getMemoQuery.data?.data;

  const onUpdate = () => {
    updateMemoMutation.mutate({
      id,
      memo: contents,
      doneAt: date,
    });
  };

  const onChange = e => {
    setContents(e.target.value);
  };

  return { contents, date, memo, setContents, setDate, onChange, onUpdate };
};

export default useErrorMemoModal;
